<template>
  <svg viewBox="0 0 1000 1000" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <g transform="translate(0 850) scale(1 -1)">
      <path
        fill="currentColor"
        d="M317 540l149 150v-490c0-20 16-35 35-35 19 0 35 15 35 35v490l149-150c7-6 16-10 24-10 9 0 18 4 25 10 14 14 14 36 0 50l-209 208c-1 2-3 3-5 5-1 0-2 0-3 1-1 1-2 1-3 2-1 0-2 0-3 1-1 0-2 1-3 1-5 1-10 1-14 0-1 0-2-1-3-1-1-1-2-1-4-1-1-1-2-1-3-2-1-1-2-1-3-1-1-2-3-3-5-5l-209-208c-13-14-13-36 0-50 14-13 36-13 50 0m-199-514h765c20 0 35 15 35 35 0 19-15 34-35 34h-765c-19 0-35-15-35-34 0-20 16-35 35-35z m765-35h-765c-19 0-35-16-35-35 0-19 16-35 35-35h765c20 0 35 16 35 35 0 19-15 35-35 35z"
      />
    </g>
  </svg>
</template>
